import React, { useState, useEffect } from 'react';
import Select from 'react-select'
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import Footer from '../Footer';
import { db } from '../../firebase';
import { collection, query, getDocs } from '@firebase/firestore';
import { convertStateToAbbreviation, createDateString, fetchCollection } from '../../utils';
import './tournaments_page.css';
import { auth } from '../../firebase';

import { countriesList, stateList } from '../../constants';

import {
  TouranmentsContainer,
  TournamentsHeader,
  TournamentsContent,
  TournamentsFiltersWrapper,
  TournamentsFilters,
} from './TournamentsPageElements';
import TournamentListElement from './TournamentListElement';

import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { format, parse, startOfWeek, getDay } from 'date-fns';

const locales = {
  'en-US': require('date-fns/locale/en-US'),
};
const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek: () => startOfWeek(new Date(), { weekStartsOn: 0 }),
  getDay,
  locales,
});

const dateFilterOptions = [
  { label: "All", value: "all" },
  { label: "Upcoming", value: "upcoming" },
  { label: "Past", value: "past" }
];

const levelColorMap = {
  'High School': '#2563eb',
  'College': '#22c55e',
  'Junior': '#f59e42',
  'Amateur': '#e11d48',
  // Add more levels and colors as needed
  'Professional': '#64748b'
};

function TournamentsPage() {

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedTournament, setSelectedTournament] = useState(null);

  const handleTournamentClick = (tournament) => {
    setSelectedTournament(tournament);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedTournament(null);
  };

  const [tournamentList, setTournamentList] = useState([])
  const [filteredTournamentList, setFilteredTournamentList] = useState([])

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const [viewMode, setViewMode] = useState('list'); // 'list' or 'calendar'

  const calendarEvents = filteredTournamentList.map(t => {
  const start = new Date(t.startDate);
  let end = t.endDate ? new Date(t.endDate) : new Date(t.startDate);
  // Add one day for all-day events so the last day is included
  end.setDate(end.getDate() + 1);
  return {
    title: t.tournamentName,
    start,
    end,
    allDay: true,
    resource: t,
  };
});

  const [selectedDateFilter, setSelectedDateFilter] = useState(dateFilterOptions[1]);

  const [loading, setLoading] = useState(true)
  const [isOpen, setIsOpen] = useState(false);



  // Data used for form values
  const [countryListForSelect, setCountryListForSelect] = useState([])
  const [stateListForSelect, setStateListForSelect] = useState([])
  const [allLevels, setAllLevels] = useState([])
  const [allTournamentTypes, setAllTournamentTypes] = useState([])
  const [allAssociations, setAllAssociations] = useState([])

  // values selected by user
  const [selectedCountries, setSelectedCountries] = useState([])
  const [selectedStates, setSelectedStates] = useState([])
  const [selectedTournamentTypes, setSelectedTournamentTypes] = useState([])
  const [selectedTournamentLevels, setSelectedTournamentLevels] = useState([])
  const [selectedTournamentAssociations, setSelectedTournamentAssociations] = useState([])

  const fetchData = async () => {
    const tournamentListLocal = []
    const q = query(collection(db, "tournaments"))
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      // console.log(doc.id, " => ", doc.data());
      const docData = doc.data()
      const tournamentObject = {
        tournamentTypes: docData.tournamentTypes,
        tournamentAssociations: docData.tournamentAssociations,
        tournamentName: docData.tournamentName,
        golfCourse: docData.golfCourses[0],
        city: docData.cities[0],
        state: docData.states[0],
        country: docData.countries[0],
        tournamentLevels: docData.tournamentLevels,
        startDate: docData.startDate,
        endDate: docData.endDate,
        id: doc.id
      }
      tournamentListLocal.push(tournamentObject)
    });
    setTournamentList(tournamentListLocal)

    const countryListForSelectLocal = []
    for (var i = 0; i < countriesList.length; i++) {
      const countryObject = {
        label: countriesList[i],
        value: countriesList[i],
        id: i
      }
      countryListForSelectLocal.push(countryObject)
    }
    setCountryListForSelect(countryListForSelectLocal)
    const stateListForSelectLocal = []
    for (var i = 0; i < stateList.length; i++) {
      const stateObject = {
        label: stateList[i],
        value: stateList[i],
        id: i
      }
      stateListForSelectLocal.push(stateObject)
    }
    setStateListForSelect(stateListForSelectLocal)
    // fetch data for filters
    // Fetch tournament types
    const tournamentTypeListLocal = []
    const tournamentTypeDocs = await fetchCollection("tournamentTypes")
    tournamentTypeDocs.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      const docData = doc.data()
      const golfCourseObject = {
        label: docData.type,
        value: docData.type,
        id: doc.id
      }
      tournamentTypeListLocal.push(golfCourseObject)
    });
    setAllTournamentTypes(tournamentTypeListLocal)

    // Fetch associations list
    const associationsListLocal = []
    const associationDocs = await fetchCollection("associations")
    associationDocs.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      const docData = doc.data()
      const associationInfoName = `${docData.name} - ${docData.associationType}`
      const associationObject = {
        label: associationInfoName,
        value: docData.name,
        id: doc.id
      }
      associationsListLocal.push(associationObject)
    });
    setAllAssociations(associationsListLocal)

    // Fetch tournament levels
    const levelsDocs = await fetchCollection("tournamentLevels")
    const levelsLocal = []
    levelsDocs.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      const docData = doc.data()
      const levelObject = {
        label: docData.level,
        value: docData.level
      }
      levelsLocal.push(levelObject)
    });
    setAllLevels(levelsLocal)
    resetSelectedValues()
    updateFilteredTournaments("init", tournamentListLocal)
    setLoading(false)
  }

  const resetSelectedValues = () => {
    setSelectedCountries([])
    setSelectedStates([])
    setSelectedTournamentLevels([])
    setSelectedTournamentAssociations([])
    setSelectedTournamentTypes([])
  }

  useEffect(() => {
    setLoading(true)
    fetchData();
  }, []);

  const renderTournamentsList = () => {
    // Sort by startDate ascending
    let sortedList = [...filteredTournamentList].sort((a, b) => {
      const dateA = new Date(a.startDate);
      const dateB = new Date(b.startDate);
      return dateA - dateB;
    });

    // Date filter
    const now = new Date();
    if (selectedDateFilter.value === "upcoming") {
      sortedList = sortedList.filter(t => new Date(t.startDate) >= now);
    } else if (selectedDateFilter.value === "past") {
      sortedList = sortedList.filter(t => new Date(t.endDate || t.startDate) < now);
    }

    // Group tournaments by month and year
    let lastMonthYear = "";
    const elements = [];
    sortedList.forEach((tournamentEntry, i) => {
      const dateObj = new Date(tournamentEntry.startDate);
      const monthYear = dateObj.toLocaleString('default', { month: 'long', year: 'numeric' });
      if (monthYear !== lastMonthYear) {
        elements.push(
          <div
            key={`month-separator-${monthYear}-${i}`}
            style={{
              fontWeight: 700,
              fontSize: "1.08rem",
              color: "#2563eb",
              margin: "1.7rem 0 0.7rem 0",
              borderBottom: "1.5px solid #dbeafe",
              paddingBottom: "0.2rem",
              letterSpacing: "0.01em"
            }}
          >
            {monthYear}
          </div>
        );
        lastMonthYear = monthYear;
      }
      const location = tournamentEntry.city + ", " + convertStateToAbbreviation(tournamentEntry.state);
      const dateString = createDateString(tournamentEntry.startDate, tournamentEntry.endDate);
      elements.push(
        <TournamentListElement
          date={dateString}
          tournamentType={tournamentEntry.tournamentTypes[0]}
          id={tournamentEntry.id}
          association={tournamentEntry.tournamentAssociations[0]}
          golfCourse={tournamentEntry.golfCourse}
          location={location}
          tournamentName={tournamentEntry.tournamentName}
          key={tournamentEntry.id}
          onClick={() => handleTournamentClick(tournamentEntry)}
        />
      );
    });
    return elements;
  };

  const updateFilteredTournaments = (updatedField, objectValue) => {

    var tournamentListLocal = tournamentList

    var selectedCountriesLocal = selectedCountries
    var selectedStatesLocal = selectedStates
    var selectedTournamentLevelsLocal = selectedTournamentLevels
    var selectedTournamentTypesLocal = selectedTournamentTypes
    var selectedTournamentAssociationsLocal = selectedTournamentAssociations

    if (updatedField == "init") {
      tournamentListLocal = objectValue
    }

    if (updatedField == "country") {
      selectedCountriesLocal = objectValue
    }
    if (updatedField == "state") {
      selectedStatesLocal = objectValue
    }
    if (updatedField == "level") {
      selectedTournamentLevelsLocal = objectValue
    }
    if (updatedField == "type") {
      selectedTournamentTypesLocal = objectValue
    }
    if (updatedField == "association") {
      selectedTournamentAssociationsLocal = objectValue
    }

    setLoading(true)
    var tournamentListFilteredByCountry = []
    // countries
    if (selectedCountriesLocal.length > 0) {
      for (var i = 0; i < tournamentListLocal.length; i++) {
        if (selectedCountriesLocal.includes(tournamentListLocal[i].country)) {
          tournamentListFilteredByCountry.push(tournamentListLocal[i])
        }
      }
    }
    else {
      tournamentListFilteredByCountry = [...tournamentListLocal]
    }

    // states
    var tournamentListFilteredByState = []
    if (selectedStatesLocal.length > 0) {
      for (var i = 0; i < tournamentListFilteredByCountry.length; i++) {
        if (selectedStatesLocal.includes(tournamentListFilteredByCountry[i].state)) {
          tournamentListFilteredByState.push(tournamentListFilteredByCountry[i])
        }
      }
    }
    else {
      tournamentListFilteredByState = [...tournamentListFilteredByCountry]
    }

    // levels
    var tournamentListFilteredByLevel = []
    if (selectedTournamentLevelsLocal.length > 0) {
      for (var i = 0; i < tournamentListFilteredByState.length; i++) {
        const levelsLocal = tournamentListFilteredByState[i].tournamentLevels
        for (var j = 0; j < levelsLocal.length; j++) {
          if (selectedTournamentLevelsLocal.includes(levelsLocal[j])) {
            tournamentListFilteredByLevel.push(tournamentListFilteredByState[i])
            break
          }
        }
      }
    }
    else {
      tournamentListFilteredByLevel = [...tournamentListFilteredByState]
    }

    // types
    var tournamentListFilteredByType = []
    if (selectedTournamentTypesLocal.length > 0) {
      for (var i = 0; i < tournamentListFilteredByLevel.length; i++) {
        const typesLocal = tournamentListFilteredByLevel[i].tournamentTypes
        for (var j = 0; j < typesLocal.length; j++) {
          if (selectedTournamentTypesLocal.includes(typesLocal[j])) {
            tournamentListFilteredByType.push(tournamentListFilteredByLevel[i])
            break
          }
        }
      }
    }
    else {
      tournamentListFilteredByType = [...tournamentListFilteredByLevel]
    }

    // association
    var tournamentListFilteredByAssociation = []
    if (selectedTournamentAssociationsLocal.length > 0) {
      for (var i = 0; i < tournamentListFilteredByType.length; i++) {
        const associationsLocal = tournamentListFilteredByType[i].tournamentAssociations
        for (var j = 0; j < associationsLocal.length; j++) {
          if (selectedTournamentAssociationsLocal.includes(associationsLocal[j])) {
            tournamentListFilteredByAssociation.push(tournamentListFilteredByType[i])
            break
          }
        }
      }
    }
    else {
      tournamentListFilteredByAssociation = [...tournamentListFilteredByType]
    }

    // update filtered list
    setFilteredTournamentList(tournamentListFilteredByAssociation)
    setLoading(false)
  }

  const changeSelectedCountries = (selectedCountryObjects) => {
    // get selected countries
    const selectedCountriesLocal = []
    for (var i = 0; i < selectedCountryObjects.length; i++) {
      selectedCountriesLocal.push(selectedCountryObjects[i].value)
    }
    setSelectedCountries(selectedCountriesLocal)
    // update displayed tournaments
    updateFilteredTournaments("country", selectedCountriesLocal)
  }

  const changeSelectedStates = (selectedStateObjects) => {
    // get selected states
    const selectedStatesLocal = []
    for (var i = 0; i < selectedStateObjects.length; i++) {
      selectedStatesLocal.push(selectedStateObjects[i].value)
    }
    setSelectedStates(selectedStatesLocal)
    // update displayed tournaments
    updateFilteredTournaments("state", selectedStatesLocal)
  }

  const changeSelectedLevels = (selectedLevelObjects) => {
    // get selected levels
    const selectedLevelsLocal = []
    for (var i = 0; i < selectedLevelObjects.length; i++) {
      selectedLevelsLocal.push(selectedLevelObjects[i].value)
    }
    setSelectedTournamentLevels(selectedLevelsLocal)
    // update displayed tournaments
    updateFilteredTournaments("level", selectedLevelsLocal)
  }

  const changeSelectedTypes = (selectedTypeObjects) => {
    // get selected types
    const selectedTypesLocal = []
    for (var i = 0; i < selectedTypeObjects.length; i++) {
      selectedTypesLocal.push(selectedTypeObjects[i].value)
    }
    setSelectedTournamentTypes(selectedTypesLocal)
    // update displayed tournaments
    updateFilteredTournaments("type", selectedTypesLocal)
  }

  const changeSelectedAssociations = (selectedAssociationObjects) => {
    // get selected associations
    const selectedAssociationsLocal = []
    for (var i = 0; i < selectedAssociationObjects.length; i++) {
      selectedAssociationsLocal.push(selectedAssociationObjects[i].value)
    }
    setSelectedTournamentAssociations(selectedAssociationsLocal)
    // update displayed tournaments
    updateFilteredTournaments("association", selectedAssociationsLocal)
  }

  if (loading) {
    return (
      <div className="tournaments-bg">
        <div className="tournaments-card">
          <div className="admin-login-loading">
            <div className="admin-login-spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <Sidebar isopen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} darkMode={false} />
      <div className="tournaments-bg">
        <div className="tournaments-card">
          <h1 className="tournaments-title">Tournaments</h1>
          <div style={{ display: "flex", gap: "1rem", marginBottom: "1.5rem" }}>
            <button
              className={`admin-login-btn${viewMode === 'list' ? ' active' : ''}`}
              style={{ padding: "0.5rem 1.2rem", fontSize: "1rem" }}
              onClick={() => setViewMode('list')}
            >
              List View
            </button>
            <button
              className={`admin-login-btn${viewMode === 'calendar' ? ' active' : ''}`}
              style={{ padding: "0.5rem 1.2rem", fontSize: "1rem" }}
              onClick={() => setViewMode('calendar')}
            >
              Calendar View
            </button>
          </div>
          <h2 className="tournaments-subtitle">Filters</h2>
          <div className="tournaments-filters-row">
            <div className="tournaments-filter">
              <label className="tournaments-filter-label">Date</label>
              <Select
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                isMulti={false}
                menuPlacement='auto'
                menuPosition='fixed'
                menuPortalTarget={typeof window !== "undefined" ? window.document.body : null}
                options={dateFilterOptions}
                value={selectedDateFilter}
                onChange={setSelectedDateFilter}
              />
            </div>
            <div className="tournaments-filter">
              <label className="tournaments-filter-label">Country</label>
              <Select styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} isMulti menuPlacement='auto' menuPortalTarget={typeof window !== "undefined" ? window.document.body : null} menuPosition='fixed' options={countryListForSelect} onChange={changeSelectedCountries} />
            </div>
            <div className="tournaments-filter">
              <label className="tournaments-filter-label">State</label>
              <Select styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} isMulti menuPlacement='auto' menuPortalTarget={typeof window !== "undefined" ? window.document.body : null} menuPosition='fixed' options={stateListForSelect} onChange={changeSelectedStates} />
            </div>
            <div className="tournaments-filter">
              <label className="tournaments-filter-label">Tournament Level</label>
              <Select styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} isMulti menuPlacement='auto' menuPortalTarget={typeof window !== "undefined" ? window.document.body : null} menuPosition='fixed' options={allLevels} onChange={changeSelectedLevels} />
            </div>
            <div className="tournaments-filter">
              <label className="tournaments-filter-label">Tournament Type</label>
              <Select styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} isMulti menuPlacement='auto' menuPortalTarget={typeof window !== "undefined" ? window.document.body : null} menuPosition='fixed' options={allTournamentTypes} onChange={changeSelectedTypes} />
            </div>
            <div className="tournaments-filter">
              <label className="tournaments-filter-label">Association</label>
              <Select styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} isMulti menuPlacement='auto' menuPortalTarget={typeof window !== "undefined" ? window.document.body : null} menuPosition='fixed' options={allAssociations} onChange={changeSelectedAssociations} />
            </div>
          </div>

          <div
            className={
              viewMode === 'list'
                ? 'tournaments-list-scroll'
                : 'tournaments-calendar-container'
            }
            style={
              viewMode === 'list'
                ? { minHeight: 400, maxHeight: 600, overflowY: 'auto' }
                : { height: 1400, minHeight: 1400, overflow: 'visible' }
            }
          >
            {viewMode === 'list' ? (
              renderTournamentsList()
            ) : (
              <Calendar
                localizer={localizer}
                events={calendarEvents}
                startAccessor="start"
                endAccessor="end"
                style={{ height: "100%", background: "#fff", borderRadius: "1rem" }}
                popup
                eventPropGetter={event => {
                  const levelArray = event.resource?.tournamentLevels || event.tournamentLevels || 'Default';
                  var level = levelArray;
                  if (Array.isArray(levelArray)) {
                    level = levelArray[0];
                  }
                  const bgColor = levelColorMap[level] || levelColorMap['Default'];
                  console.log("bgColor", bgColor)
                  return {
                    style: {
                      background: bgColor,
                      color: "#fff",
                      borderRadius: "7px",
                      boxShadow: "0 2px 8px rgba(37,99,235,0.08)",
                    }
                  };
                }}
                onSelectEvent={event => handleTournamentClick(event.resource)}
              />
            )}
          </div>
          <button
            className="admin-login-btn tournaments-logout-btn"
            style={{ marginTop: "2.5rem", width: "100%" }}
            onClick={() => auth.signOut()}
          >
            Log Out
          </button>
        </div>
      </div>
      <Footer />
      {modalOpen && selectedTournament && (
        <div className="tournament-modal-overlay" onClick={closeModal}>
          <div className="tournament-modal" onClick={e => e.stopPropagation()}>
            <button className="tournament-modal-close" onClick={closeModal}>×</button>
            <h2 className="tournament-modal-title">{selectedTournament.tournamentName}</h2>
            <div className="tournament-modal-info">
              <div><b>Location:</b> {selectedTournament.city + ", " + convertStateToAbbreviation(selectedTournament.state)}</div>
              <div><b>Type:</b> {selectedTournament.tournamentTypes}</div>
              <div><b>Association:</b> {selectedTournament.tournamentAssociations}</div>
              <div><b>Course:</b> {selectedTournament.golfCourse}</div>
              <div><b>Start Date:</b> {selectedTournament.startDate}</div>
              <div><b>End Date:</b> {selectedTournament.endDate}</div>
            </div>
            <button
              className="admin-login-btn"
              style={{ marginTop: "1.2rem", width: "100%" }}
              onClick={() => window.location.href = `/tournaments/detail?${selectedTournament.id}`}
            >
              Go to Tournament Details
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default TournamentsPage;